module.exports = __webpack_public_path__ + "media/images/ninestars/apple-touch-icon-d2525de997b2479b0867ad94e0799c0a.png";